import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ems-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss']
})
export class LogoComponent implements OnInit {

  @Input() showCompany: boolean = true;
  @Input() showMotto: boolean = true;
  @Input() showImage: boolean = true;
  @Input() darkBackground: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

}
